import React from 'react';
import { useQuery } from '@apollo/client';
import productListBySkus from 'src/queries/productListBySkus.graphql';
import { BasketUpsellItem } from 'src/components/Basket/upsell/BasketUpsellItem';
import { StaticSpinner } from 'src/components/Layout/Spinner';
import Bugsnag from '@bugsnag/js';
import { blogCarouselSettings } from 'src/elements/Carousel/settings';
import Slider from 'src/elements/Carousel/Slider';

import classes from './RelatedBlogProducts.scss';

type Props = { relatedProducts: string[] };

export const RelatedBlogProducts: React.FC<Props> = ({ relatedProducts }) => {
    const { error, data, loading } = useQuery(productListBySkus, {
        variables: {
            skus: relatedProducts,
        },
    });

    if (loading) return <StaticSpinner />;

    if (!data || error) {
        Bugsnag.notify(`Error: ${error}`);
        return null;
    }

    return (
        <div className={classes.container}>
            <Slider {...blogCarouselSettings} className={classes.slider}>
                {data.productList.map((product, key) => (
                    <ul className={classes.upsellItemWrapper} key={key}>
                        <BasketUpsellItem item={product} />
                    </ul>
                ))}
            </Slider>
        </div>
    );
};
